App = App || {};

App.ItemDetail = (function ($, Vue) {
	"use strict";

	var $modal;
	function init(rootElement) {
		rootElement = rootElement || document.getElementById("item-detail-app");

		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				isLoading: false,
				isSaving: false,
				isSaved: false,
				alertMessage: "",
				alertErrors: [],
				itemGroups: [],
				selectedItem: {
					prices: [],
					serials: []
				}
			},

			computed: {
				hasSerials: function () {
					return Array.isArray(this.selectedItem.serials) && this.selectedItem.serials.length > 0;
				},
			},

			methods: {
				pricesByAspect: function (item, aspect) {
					var prices = Array.isArray(item && item.prices) ? item.prices : [];
					return prices.filter((price) => price.aspect === aspect);
				},

				formatDate: function (value) {
					if (!value)
						return "";
					var normalized = String(value).replace(/(\.\d{3})\d+$/, "$1");
					var d = new Date(normalized);
					return isNaN(d) ? String(value) : d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
				},

				clearState: function () {
					this.isLoading = false;
					this.isSaved = false;
					this.isSaving = false;
					this.alertMessage = "";
					this.alertErrors = [];
					this.itemGroups = [];
					this.selectedItem = { prices: [], serials: [] };
				},

				close: function () {
					$modal.modal("hide");
				},

				loadItem: function () {
					var id = $modal.data("id");

					if (!id) {
						this.alertMessage = "No item id provided.";
						return;
					}

					return $.ajax({
						url: "/api/items/" + encodeURIComponent(id),
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000
					})
						.done((resp) => {
							if (resp && resp.success && resp.data) {
								this.selectedItem = resp.data;
							} else {
								this.alertMessage = (resp && resp.message) || "Unable to load item.";
							}
						})
						.fail((jqXHR, status) => {
							this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Item not found (404)." :
								(status === "timeout" ? "Request timed out." : "Failed to load item.");
						});
				},

				loadItemGroups: function () {
					return $.ajax({
						url: "/api/lookups/item_groups",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.itemGroups = resp.data;
						} else {
							this.itemGroups = [];
						}
					}).fail(() => {
						this.itemGroups = [];
					});
				},

				confirmClear: function (serial) {
					var ok = window.confirm('Are you sure you want to clear this serial? This cannot be undone.');
					if (!ok)
						return;

					this.$set(serial, '_saving', true);

					$.ajax({
						url: "/api/serials/clear",
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify(serial),
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							this.loadItem();
						}
					}).catch((error) => {
						console.error("Serials provider error:", error);
					}).always(() => {
						this.$set(serial, '_saving', false);
					});
				},

				onSerialRowClick: function (serial) {
					if (!serial || !serial.claimed)
						return;

					if (!serial.transactionId)
						return;

					$modal.modal("hide");
					App.TransactionDetail.open(serial.transactionId, () => $modal.modal("show"));
				},

				save: function () {
					if (!this.selectedItem || !this.selectedItem.id)
						return;

					this.isSaving = true;
					this.alertMessage = "";
					this.isSaved = false;

					$.ajax({
						url: "/api/items/" + encodeURIComponent(this.selectedItem.id),
						method: "PUT",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: JSON.stringify(this.selectedItem),
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).done((resp) => {
						if (resp && resp.success && resp.data) {
							this.selectedItem = resp.data;
							this.isSaved = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (resp && resp.message) || "Save failed.";
						}
					}).fail((jqXHR, status) => {
						this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Item not found (404)." :
							(status === "timeout" ? "Request timed out." : "Save failed.");
					}).always(() => {
						this.isSaving = false;
					});
				}
			},

			mounted: function () {
				$modal.off("show.bs.modal hidden.bs.modal");

				$modal.on("show.bs.modal", () => {
					this.clearState();
					this.isLoading = true;

					$.when(this.loadItem(), this.loadItemGroups())
						.always(() => {
							this.isLoading = false;
						});
				});

				$modal.on("shown.bs.modal", () => {
					$modal.find("#close-icon").focus();
				});
			}
		});
	}

	function open(id, onClose) {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return {
		init: init,
		open: open
	};
})(jQuery, Vue);

App.ItemDetail.init();